import React from "react";

// Each brand is rendered on a soft white "pill" so brand colours (Aten blue,
// Dyeton red circle, Quantron mark, etc.) preserve integrity on the dark marquee.
// SimpleIcons monochrome marks are also placed on white pills for consistency.
const BRANDS = [
  { name: "HP",        src: "https://cdn.simpleicons.org/hp/222222" },
  { name: "Dell",      src: "https://cdn.simpleicons.org/dell/222222" },
  { name: "Lenovo",    src: "https://cdn.simpleicons.org/lenovo/222222" },
  { name: "Hikvision", src: "/brand/partners/hikvision.svg" },
  { name: "D-Link",    src: "/brand/partners/dlink.svg" },
  { name: "Aten",      src: "/brand/partners/aten.png" },
  { name: "Dyeton",    src: "/brand/partners/dyeton.png" },
  { name: "Quantron",  src: "/brand/partners/quantron.png" },
  { name: "Bestnet",   src: "/brand/partners/bestnet.png" },
];

function BrandPlate({ b }) {
  const [failed, setFailed] = React.useState(false);
  return (
    <span
      className="inline-flex items-center gap-6 mx-6 lg:mx-8"
      data-testid={`brand-plate-${b.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
    >
      <span
        className="inline-flex items-center justify-center bg-[#FAFAFA] rounded-lg px-6 py-4 h-[74px] lg:h-[88px] w-[172px] lg:w-[200px] shadow-[0_10px_30px_-16px_rgba(0,0,0,0.6)] border border-white/8 grayscale-0 hover:scale-[1.03] transition-transform duration-500"
      >
        {failed ? (
          <span className="font-display text-[#222222] text-[20px] lg:text-[24px] tracking-tight">
            {b.name}
          </span>
        ) : (
          <img
            src={b.src}
            alt={b.name}
            onError={() => setFailed(true)}
            className="max-h-[44px] lg:max-h-[56px] w-auto max-w-full object-contain"
            loading="lazy"
          />
        )}
      </span>
      <span className="inline-block w-2 h-2 rounded-full bg-[#A4161A]/70 flex-shrink-0" aria-hidden="true" />
    </span>
  );
}

export default function BrandsMarquee() {
  const row = [...BRANDS, ...BRANDS];
  return (
    <section id="brands" className="bg-[#222222] py-14 lg:py-16 border-y border-[#9A9A9A]/12 overflow-hidden" data-testid="brands-section">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 mb-10 flex items-center justify-between flex-wrap gap-3">
        <div className="section-label">Brands We Deal In</div>
        <div className="text-[#9A9A9A] text-[12px] tracking-[0.2em] uppercase font-btn">Authorised · Genuine · Warranted</div>
      </div>

      <div className="relative">
        <div className="pointer-events-none absolute inset-y-0 left-0 w-24 z-10 bg-gradient-to-r from-[#222222] to-transparent" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-24 z-10 bg-gradient-to-l from-[#222222] to-transparent" />
        <div className="marquee-track items-center" data-testid="brands-marquee">
          {row.map((b, i) => (
            <BrandPlate key={`${b.name}-${i}`} b={b} />
          ))}
        </div>
      </div>
    </section>
  );
}
